/* One paused/resumed WAAPI timeline drives both the visible progress and each pair change. */
(()=>{
  'use strict';
  if(customElements.get('r26-duo-player'))return;
  class DuoPlayer extends HTMLElement{
    connectedCallback(){
      if(this.abort)return;
      this.tabs=[...this.querySelectorAll('[role="tab"]')];
      this.panels=this.tabs.map(tab=>this.querySelector('#'+CSS.escape(tab.getAttribute('aria-controls'))));
      this.controls=this.querySelector('[data-duo-playback]');this.toggle=this.querySelector('[data-duo-toggle]');
      if(!this.tabs.length||this.panels.some(panel=>!panel))return;
      this.abort=new AbortController();const signal=this.abort.signal;
      this.index=Math.max(0,this.tabs.findIndex(tab=>tab.getAttribute('aria-selected')==='true'));
      this.visible=false;this.pointerHeld=false;this.keyboard=false;this.pageInactive=false;this.waitingForImage=false;
      this.userPaused=Boolean(this.userPaused);this.rmOptIn=false;this.rm=matchMedia('(prefers-reduced-motion:reduce)');
      this.cycle=(this.cycle||0)+1;
      this.addEventListener('pointerdown',()=>{this.keyboard=false;this.dataset.duoInput='pointer';this.pointerHeld=true;this.sync();},{signal});
      document.addEventListener('pointerup',()=>{if(this.pointerHeld){this.pointerHeld=false;clearTimeout(this.release);this.release=setTimeout(()=>this.sync(),0);}},{signal});
      document.addEventListener('pointercancel',()=>{this.pointerHeld=false;this.sync();},{signal});
      this.addEventListener('keydown',()=>{this.keyboard=true;this.dataset.duoInput='keyboard';this.sync();},{signal});
      document.addEventListener('keydown',event=>{if(event.key==='Tab'){this.keyboard=true;this.sync();}},{signal});
      document.addEventListener('focusin',()=>this.sync(),{signal});
      this.addEventListener('focusout',()=>queueMicrotask(()=>this.sync()),{signal});
      this.tabs.forEach((tab,index)=>{
        tab.addEventListener('click',event=>this.show(index,event.detail===0?'keyboard':'manual'),{signal});
        tab.addEventListener('keydown',event=>{
          let next;
          if(event.key==='ArrowRight')next=(index+1)%this.tabs.length;
          if(event.key==='ArrowLeft')next=(index+this.tabs.length-1)%this.tabs.length;
          if(event.key==='Home')next=0;if(event.key==='End')next=this.tabs.length-1;
          if(next===undefined)return;
          event.preventDefault();this.keyboard=true;this.tabs[next].focus({preventScroll:true});this.show(next,'keyboard');
        },{signal});
      });
      if(this.tabs.length<2||!this.controls||!this.toggle)return;
      this.duration=matchMedia('(max-width:767px)').matches?10000:6000;
      this.timeline=this.querySelector('[data-duo-progress]').animate([{transform:'scaleX(0)'},{transform:'scaleX(1)'}],{duration:this.duration,easing:'linear',fill:'both'});
      this.timeline.pause();this.timeline.currentTime=0;
      this.timeline.onfinish=async()=>{
        if(!this.abort||this.timeline.currentTime<this.duration-5)return;
        if(!this.canRun()){this.timeline.currentTime=0;this.sync();return;}
        const ticket=this.cycle,next=(this.index+1)%this.tabs.length,image=this.panels[next].querySelector('.r24-duo-editorial>img');
        this.waitingForImage=true;this.timeline.pause();let decoded=true;
        if(image){try{await image.decode();decoded=image.naturalWidth>0;}catch(_){decoded=false;}}
        if(!this.abort||ticket!==this.cycle)return;
        this.waitingForImage=false;
        if(!decoded){this.userPaused=true;this.sync();return;}
        if(this.canRun())this.show(next,'auto');else{this.timeline.currentTime=0;this.sync();}
      };
      this.toggle.addEventListener('click',()=>{
        if(this.paused()){this.userPaused=false;this.rmOptIn=true;}else{this.userPaused=true;}
        this.sync();
      },{signal});
      this.rm.addEventListener('change',()=>{this.rmOptIn=false;this.reveal?.cancel();this.sync();},{signal});
      document.addEventListener('visibilitychange',()=>this.sync(),{signal});
      window.addEventListener('pagehide',()=>{this.pageInactive=true;this.sync();},{signal});
      window.addEventListener('pageshow',()=>{this.pageInactive=false;this.sync();},{signal});
      this.dialogs=new MutationObserver(()=>this.sync());this.dialogs.observe(document.body,{subtree:true,attributes:true,attributeFilter:['open']});
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting&&entries[0].intersectionRatio>=.15;this.sync();},{threshold:[0,.15]});this.observer.observe(this);
      this.controls.hidden=false;this.dataset.duoReady='true';this.sync();
    }
    paused(){return this.userPaused||(this.rm?.matches&&!this.rmOptIn);}
    canRun(){
      const focus=document.activeElement,inside=this.contains(focus),onToggle=this.toggle?.contains(focus),onTab=this.tabs?.some(tab=>tab.contains(focus));
      return this.isConnected&&!this.pageInactive&&this.visible&&!document.hidden&&!this.paused()&&!this.pointerHeld&&!document.querySelector('dialog[open]')&&!(inside&&!onToggle&&(this.keyboard||!onTab));
    }
    sync(){
      if(!this.abort||!this.timeline)return;
      const running=this.canRun()&&!this.waitingForImage;
      if(running){
        const next=this.panels[(this.index+1)%this.tabs.length].querySelector('.r24-duo-editorial>img');if(next)next.loading='eager';
        if(this.timeline.playState!=='running')this.timeline.play();
      }else this.timeline.pause();
      this.dataset.duoPlaying=String(running);this.dataset.duoPaused=String(this.paused());
      this.toggle.setAttribute('aria-label',this.toggle.dataset[this.paused()?'play':'pause']);
      this.toggle.querySelector('[data-duo-play]').hidden=!this.paused();this.toggle.querySelector('[data-duo-pause]').hidden=this.paused();
    }
    show(index,source){
      if(!this.abort)return;
      this.index=index;this.cycle++;this.waitingForImage=false;this.reveal?.cancel();
      this.tabs.forEach((tab,i)=>{const selected=i===index;tab.setAttribute('aria-selected',String(selected));tab.tabIndex=selected?0:-1;this.panels[i].hidden=!selected;});
      if(source!=='keyboard'&&!this.rm.matches){const image=this.panels[index].querySelector('.r24-duo-editorial');this.reveal=image?.animate([{opacity:.65},{opacity:1}],{duration:220,easing:'cubic-bezier(.23,1,.32,1)'});}
      const tab=this.tabs[index],rail=tab.parentElement,left=tab.offsetLeft-rail.offsetLeft;
      if(left<rail.scrollLeft)rail.scrollTo({left,behavior:'instant'});else if(left+tab.offsetWidth>rail.scrollLeft+rail.clientWidth)rail.scrollTo({left:left+tab.offsetWidth-rail.clientWidth,behavior:'instant'});
      if(this.timeline)this.timeline.currentTime=0;
      this.sync();
    }
    disconnectedCallback(){
      this.abort?.abort();this.abort=null;this.observer?.disconnect();this.dialogs?.disconnect();this.timeline?.cancel();this.reveal?.cancel();clearTimeout(this.release);this.timeline=null;this.dataset.duoPlaying='false';
    }
  }
  customElements.define('r26-duo-player',DuoPlayer);
})();
